import { render, staticRenderFns } from "./ImprimBookTopHeader.vue?vue&type=template&id=25408201&scoped=true&"
import script from "./ImprimBookTopHeader.vue?vue&type=script&lang=js&"
export * from "./ImprimBookTopHeader.vue?vue&type=script&lang=js&"
import style0 from "./ImprimBookTopHeader.vue?vue&type=style&index=0&id=25408201&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25408201",
  null
  
)

export default component.exports